import React, { Component } from 'react';

class ProductImage extends Component {
  timeout = null;

  state = {
    loading: true,
    failed: false,
  };

  componentDidMount() {
    this.timeout = setTimeout(() => {
      this.setState({ failed: true, loading: false });
    }, 3000);
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  handleImageLoad = () => {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.setState({ loading: false });
  };

  handleImageError = () => {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.setState({ loading: false, failed: true });
  };

  render() {
    const { uuid, name, style, onClick } = this.props;
    const { loading, failed } = this.state;

    return (
      <div style={{ position: 'relative', display: 'inline-block', ...style }}>
        {!failed && (
          <img
            src={`/api/image/1/${uuid}`}
            alt={name}
            title={name}
            onLoad={this.handleImageLoad}
            onError={this.handleImageError}
            style={{
              display: loading ? 'none' : 'block',
              maxWidth: '100%',
              maxHeight: '100%',
              cursor: onClick ? 'pointer' : 'default',
            }}
            onClick={onClick || undefined}
          />
        )}

        {failed && (
          <img
            src="/images/nophoto.png"
            alt="no photo"
            title={name}
            style={{
              display: loading ? 'none' : 'block',
              maxWidth: '100%',
              maxHeight: '100%',
              cursor: onClick ? 'pointer' : 'default',
              transition: 'transform 0.3s ease',
            }}
            onClick={onClick || undefined}
          />
        )}

        {loading && !failed && (
          <img
            src="/images/icons/progress.gif"
            alt="loading"
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              pointerEvents: 'none',
            }}
          />
        )}
      </div>
    );
  }
}

export default ProductImage;